import { baseApi } from '@/shared/api'
import type { SerialsList, SerialsQuery } from '../model/types'

export const serialApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Проверка серийного номера. Поиск, страница и итоги — на сервере (правило 11); параметры
     * уходят как есть, их имена — имена ручки. Модификатор контекста не добавляется: `?client=`
     * ручка отвергает `400`. Полноту строк решает бэк по праву `serial.full.view`.
     */
    getSerials: build.query<SerialsList, SerialsQuery>({
      query: (params) => ({ url: '/serials', params }),
      providesTags: [{ type: 'Serial', id: 'SEARCH' }],
    }),
  }),
})

export const { useGetSerialsQuery } = serialApi
